// @flow

import { connect } from "react-redux";
import BlogCard from "./view";
import Photos from "./photos";
import { fetchBlog, showBlog, fetchBlogImages } from "../state/blogs/actions";

export default connect(
    () => ({ Photos }),
    dispatch => ({
        onFetchBlog: id => dispatch(fetchBlog(id)),
        onFetchBlogImages: id => dispatch(fetchBlogImages(id)),
        onShowBlog: blog => dispatch(showBlog(blog))
    })
)(BlogCard);



// WEBPACK FOOTER //
// ./src/blog-card/index.js